import { applyVueInReact } from 'vuereact-combined';

import { default as VueAppIcon } from '@/components/atoms/AppIcon.vue';

const ReactAppIcon = applyVueInReact(VueAppIcon);

export const AppIcon = ({
	name,
	iconColor = '#2684FF',
	width,
	height,
}: {
	name: string;
	iconColor?: string;
	width?: number | string;
	height?: number | string;
}) => <ReactAppIcon name={name} iconColor={iconColor} width={width} height={height} />;
export default AppIcon;
